import { useState } from 'react';
import { NavbarIconButtonWithLabel } from '../navbar/components/NavbarIconButtonWithLabel';
import { DuckDbIcon } from '../navbar/components/icons/DuckDbIcon';
import { DuckDBShellDialog } from './DuckDBShellDialog';
import { QueryRunner } from './QueryRunner';

export const DuckDBLauncher = () => {
  const [queryRunnerOpen, setQueryRunnerOpen] = useState(false);
  const [shellOpen, setShellOpen] = useState(false);

  const isActive = queryRunnerOpen || shellOpen;

  return (
    <>
      <NavbarIconButtonWithLabel
        active={isActive}
        label='DuckDB'
        onClick={() => {
          if (!shellOpen) {
            setShellOpen(true);
          }
          if (!queryRunnerOpen) {
            setQueryRunnerOpen(true);
          }
        }}
      >
        <DuckDbIcon />
      </NavbarIconButtonWithLabel>
      <QueryRunner
        open={queryRunnerOpen}
        onClose={() => setQueryRunnerOpen(false)}
      />
      <DuckDBShellDialog open={shellOpen} onClose={() => setShellOpen(false)} />
    </>
  );
};
